// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const SplineCutOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M1.23 6.76c1.55 1.14 8 4.67 8.13-.27.12-4.93 2.9-3.55 4.62-2.51","stroke-dasharray":"1 3","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","stroke":"currentColor"}},{"tag":"path","attrs":{"d":"M7.06 14.08h6.33V7.7a.94.94 0 111.87 0v6.38h2.04a2.82 2.82 0 112.65 1.88h-4.69v4.73a2.82 2.82 0 01-2.8 2.76.94.94 0 110-1.87.94.94 0 10-.95-.94.94.94 0 11-1.87 0 2.82 2.82 0 013.75-2.65v-2.04H7.06a.94.94 0 110-1.87zm13.83-.94a.94.94 0 10-1.88 0 .94.94 0 001.88 0z","fill":"currentColor"}}]},"name":"spline-cut","theme":"outlined"};

const SplineCutOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={SplineCutOutlinedSvg} />;
  SplineCutOutlined.displayName = 'SplineCutOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(SplineCutOutlined);
